module.exports = __webpack_public_path__ + "img/icon-game-7314.ebfe523f.png";